import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import gadgets from 'assets/images/digital-loan/catalog-families/gadgets.png';
import deportivos from 'assets/images/digital-loan/catalog-families/deportivos.png';
import electrodomesticos from 'assets/images/digital-loan/catalog-families/electrodomesticos.png';
import audioVideo from 'assets/images/digital-loan/catalog-families/audio-video.png';
import vehiculos from 'assets/images/digital-loan/catalog-families/vehiculos.png';
import otros from 'assets/images/digital-loan/catalog-families/otros.png';
import maquinaria from 'assets/images/digital-loan/catalog-families/maquinaria.png';
import hogar from 'assets/images/digital-loan/catalog-families/hogar.png';
import herramienta from 'assets/images/digital-loan/catalog-families/herramienta.png';
import { ReactComponent as AccessIcon } from 'assets/icons/access.svg';
import { isCatalogOtherSelection, withManualOtherOption } from 'routes/DigitalLoan/utils/catalogOtherOption';

/**
 * Arte de familia por nombre normalizado (solo UI).
 * El id de catálogo no se modifica. OTRO manual no usa estas piezas.
 */
export function getFamilyCardImage(name = '') {
  const normalized = String(name)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  if (normalized === 'otro') {
    return null;
  }
  if (normalized.includes('deportiv')) {
    return { src: deportivos };
  }
  if (normalized.includes('audio') || normalized.includes('video')) {
    return { src: audioVideo };
  }
  if (normalized.includes('electrodomest') || normalized.includes('domestic')) {
    return { src: electrodomesticos };
  }
  if (normalized.includes('gadget')) {
    return { src: gadgets };
  }
  if (normalized.includes('herramient')) {
    return { src: herramienta };
  }
  if (normalized.includes('hogar')) {
    return { src: hogar };
  }
  if (normalized.includes('maquinaria')) {
    return { src: maquinaria };
  }
  if (normalized.includes('vehicul')) {
    return { src: vehiculos };
  }
  if (normalized === 'otros' || normalized.includes('otros')) {
    return { src: otros };
  }
  return null;
}

const CatalogSelectionScreen = ({
  literals,
  items,
  variant = 'list',
  onSelect,
  onBack,
  loading = false,
}) => {
  const visibleItems = withManualOtherOption(items);

  return (
    <div className={`full-screen-container digital-loan-catalog digital-loan-catalog--${variant}`}>
      <div className='screen-content'>
        <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
        {literals.subtitle && (
          <p className='digital-loan-phase2__body'>{literals.subtitle}</p>
        )}
        {literals.note && (
          <p className='digital-loan-catalog__note'>{literals.note}</p>
        )}
        {loading && (
          <p className='digital-loan-catalog__loading'>{literals.loading}</p>
        )}
        {!loading && variant === 'grid' && (
          <div className='digital-loan-catalog__grid'>
            {visibleItems.map((item) => {
              const image = getFamilyCardImage(item.name);
              const isOther = isCatalogOtherSelection(item);
              return (
                <button
                  key={item.id}
                  type='button'
                  className={`digital-loan-catalog__grid-item${image ? ' digital-loan-catalog__grid-item--artwork' : ''}${isOther ? ' digital-loan-catalog__grid-item--other' : ''}`}
                  onClick={() => onSelect(item)}
                >
                  {image ? (
                    <img
                      className='digital-loan-catalog__grid-image digital-loan-catalog__grid-image--artwork'
                      src={image.src}
                      alt=''
                    />
                  ) : (
                    <span className='digital-loan-catalog__grid-placeholder' aria-hidden='true' />
                  )}
                  <span className={`digital-loan-catalog__grid-label${image ? ' digital-loan-catalog__grid-label--sr' : ''}`}>
                    {item.name}
                  </span>
                </button>
              );
            })}
          </div>
        )}
        {!loading && variant === 'list' && (
          <div className='digital-loan-catalog__list'>
            {visibleItems.map((item) => {
              const isOther = isCatalogOtherSelection(item);
              return (
                <button
                  key={item.id}
                  type='button'
                  className={`digital-loan-catalog__list-item ${isOther ? 'digital-loan-catalog__list-item--other' : ''}`}
                  onClick={() => onSelect(item)}
                >
                  <span>{item.name}</span>
                  <AccessIcon
                    className='digital-loan-catalog__list-arrow'
                    aria-hidden='true'
                  />
                </button>
              );
            })}
          </div>
        )}
      </div>
      <div className='screen-actions'>
        <Button text={literals.back} type='secondary' onClick={onBack} />
      </div>
    </div>
  );
};

CatalogSelectionScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  variant: PropTypes.oneOf(['grid', 'list']),
  onSelect: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default CatalogSelectionScreen;
